module.exports = __webpack_public_path__ + "img/drag-and-drop-icon.e4c677f5.svg";